module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('column', {
    staticClass: "col-lg-2"
  }, [_c('va-box', {
    attrs: {
      "title": "Reports list",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(0 > 1) ? _c('input', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-top": "20px",
      "width": "100%"
    },
    attrs: {
      "type": "button",
      "value": "Run Test"
    },
    on: {
      "click": _vm.test
    }
  }) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v("Select Report:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportKey),
      expression: "reportKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reportKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.reports), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data": item
      },
      domProps: {
        "value": item['.key']
      }
    }, [_vm._v("\n            " + _vm._s(item.Name) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('h5', [_vm._v("Filters:")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$root.isAdmin && _vm.report && _vm.report.Filters && _vm.report.Filters.DealerKey),
      expression: "$root.isAdmin && report && report.Filters && report.Filters.DealerKey"
    }],
    staticClass: "divReportFilter"
  }, [_c('span', [_vm._v("Dealer:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.dealerKey),
      expression: "filters.dealerKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "dealerKey", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.sortedDelaers), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report && _vm.report.Filters && _vm.report.Filters.CustomerKey && _vm.filters.dealerKey !== 'All' && !_vm.$root.isCustomer),
      expression: "report && report.Filters && report.Filters.CustomerKey && filters.dealerKey !== 'All' && !$root.isCustomer"
    }],
    staticClass: "divReportFilter"
  }, [_c('span', [_vm._v("Customer:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.customerKey),
      expression: "filters.customerKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "customerKey", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All",
      "selected": "selected"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.customers), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report && _vm.report.Filters && _vm.report.Filters.SiteKey && _vm.filters.customerKey !== 'All'),
      expression: "report && report.Filters && report.Filters.SiteKey && filters.customerKey !== 'All'"
    }],
    staticClass: "divReportFilter"
  }, [_c('span', [_vm._v("Site:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.siteKey),
      expression: "filters.siteKey"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "siteKey", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All",
      "selected": "selected"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.sites), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report && _vm.report.Filters && _vm.report.Filters.PrinterKey),
      expression: "report && report.Filters && report.Filters.PrinterKey"
    }],
    staticClass: "divReportFilter"
  }, [_c('span', [_vm._v("Printer MAC:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.printerKey),
      expression: "filters.printerKey"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter MAC Address"
    },
    domProps: {
      "value": (_vm.filters.printerKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "printerKey", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report && _vm.report.Filters && _vm.report.Filters.Monthly),
      expression: "report && report.Filters && report.Filters.Monthly"
    }],
    staticClass: "divReportFilter"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-sm-6"
  }, [_vm._v("Month:")]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-6"
  }, [_vm._v("Year:")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.month),
      expression: "filters.month"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "width": "50px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.months), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.year),
      expression: "filters.year"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.years), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report && _vm.report.Filters && _vm.report.Filters.FromDate && !_vm.report.Filters.Monthly),
      expression: "report && report.Filters && report.Filters.FromDate && !report.Filters.Monthly"
    }],
    staticClass: "divReportFilter"
  }, [_c('span', [_vm._v("From Date:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.fromDate),
      expression: "filters.fromDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "Enter MAC Address"
    },
    domProps: {
      "value": (_vm.filters.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "fromDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report && _vm.report.Filters && _vm.report.Filters.ToDate && !_vm.report.Filters.Monthly),
      expression: "report && report.Filters && report.Filters.ToDate && !report.Filters.Monthly"
    }],
    staticClass: "divReportFilter"
  }, [_c('span', [_vm._v("To Date:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.toDate),
      expression: "filters.toDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "min": "filters.fromDate",
      "placeholder": "Enter MAC Address"
    },
    domProps: {
      "value": (_vm.filters.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "toDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.report && _vm.report.Filters && _vm.report.Filters.DateRange),
      expression: "report && report.Filters && report.Filters.DateRange"
    }],
    staticClass: "divReportFilter"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-sm-12"
  }, [_vm._v("From Date:")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.fromMonth),
      expression: "filters.fromMonth"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "width": "50px",
      "float": "left"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "fromMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.months), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left",
      "font-size": "20px",
      "padding": "5px"
    }
  }, [_vm._v("/")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.fromYear),
      expression: "filters.fromYear"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "width": "80px",
      "float": "left"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "fromYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.years), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-sm-12"
  }, [_vm._v("To Date:")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.toMonth),
      expression: "filters.toMonth"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "width": "50px",
      "float": "left"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "toMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.months), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left",
      "font-size": "20px",
      "padding": "5px"
    }
  }, [_vm._v("/")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.toYear),
      expression: "filters.toYear"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "width": "80px",
      "float": "left"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "toYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.years), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasReportHistory && _vm.isUsageReport),
      expression: "hasReportHistory && isUsageReport"
    }],
    staticClass: "divReportFilter"
  }, [_c('hr'), _vm._v(" "), _c('h5', [_vm._v("Report History:")]), _vm._v(" "), _c('span', [_vm._v("Generated: ")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.reportHistory.GenerateDate))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Printed: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.reportHistory.PrintDate))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Exported: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.reportHistory.ExportDate))])]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "20px",
      "width": "100%"
    },
    attrs: {
      "type": "button",
      "value": "Run Report"
    },
    on: {
      "click": _vm.runReport
    }
  })])])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.report ? _vm.report.Name : ''))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right box-tools"
  }, [(_vm.$root.isAdmin) ? _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "title": "Edit Report"
    },
    on: {
      "click": _vm.editReportAdmin
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "font-size": "18px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$root.isAdmin) ? _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "title": "Edit Report"
    },
    on: {
      "click": _vm.editReport
    }
  }, [_c('i', {
    staticClass: "fa fa-paint-brush",
    staticStyle: {
      "font-size": "18px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "title": "Save as PDF"
    },
    on: {
      "click": _vm.exportPDF
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "title": "Save as CSV"
    },
    on: {
      "click": _vm.exportCSV
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "title": "Print"
    },
    on: {
      "click": _vm.print
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    staticStyle: {
      "font-size": "18px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticStyle: {
      "min-height": "450px",
      "height": "100%",
      "background-color": "#ccc",
      "padding": "10px"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": _vm.isFullpage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasData),
      expression: "hasData"
    }],
    staticClass: "report-output",
    staticStyle: {
      "width": "100%",
      "height": "550px",
      "border": "none"
    },
    attrs: {
      "id": "iframReport",
      "type": "application/pdf"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasData),
      expression: "!hasData"
    }]
  }, [_c('h3', [_vm._v("No Data To show!")]), _vm._v(" "), _c('h4', [_vm._v("Please select a report from the list in the left panel !")]), _vm._v(" "), _c('h5', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.error))])])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35e53334!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports.vue
// module id = 690
// module chunks = 0